import { createAsyncStore } from "../../utils/createAsyncStore";
import { ProducerDTO } from "./dto";

export const useProducerAsyncStore = createAsyncStore<any>({
  defaultValue: undefined,
  persistKey: "producer",
  debugName: "producer",
  userPrivate: false,
});
